'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _connectMenu = require('../connectors/connectMenu');

var _connectMenu2 = _interopRequireDefault(_connectMenu);

var _PanelCallbackHandler = require('../components/PanelCallbackHandler');

var _PanelCallbackHandler2 = _interopRequireDefault(_PanelCallbackHandler);

var _MenuSelect = require('../components/MenuSelect');

var _MenuSelect2 = _interopRequireDefault(_MenuSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The MenuSelect component displays a select that lets the user choose a single value for a specific attribute.
 * @name MenuSelect
 * @kind widget
 * @requirements The attribute passed to the `attribute` prop must be present in "attributes for faceting"
 * on the Algolia dashboard or configured as `attributesForFaceting` via a set settings call to the Algolia API.
 * @propType {string} attribute - the name of the attribute in the record
 * @propType {string} [defaultRefinement] - the value of the item selected by default
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @themeKey ais-MenuSelect - the root div of the widget
 * @themeKey ais-MenuSelect-noRefinement - the root div of the widget when there is no refinement
 * @themeKey ais-MenuSelect-select - the `<select>`
 * @themeKey ais-MenuSelect-option - the select `<option>`
 * @translationkey seeAllOption - The label of the option to select to remove the refinement
 * @example
 * import React from 'react';
 * import { InstantSearch, MenuSelect } from 'react-instantsearch/dom';
 *
 * const App = () => (
 *   <InstantSearch
 *     appId="latency"
 *     apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *     indexName="ikea"
 *   >
 *     <MenuSelect attribute="category" />
 *   </InstantSearch>
 * );
 */

var MenuSelectWidget = function MenuSelectWidget(props) {
  return _react2.default.createElement(
    _PanelCallbackHandler2.default,
    props,
    _react2.default.createElement(_MenuSelect2.default, props)
  );
};

exports.default = (0, _connectMenu2.default)(MenuSelectWidget);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/widgets/MenuSelect.js
// module id = 1303
// module chunks = 142807904292071